namespace('compass.tiles');

compass.tiles.EventInfoTileWidget = compass.defineWidget(function EventInfoTileWidget(options) {
	var me = this;
	var $j = jQuery;

	this.render = function(widgetElem) {
		widgetElem.append(d.a({ href:options.meetingInfo.homePageUrl, className : 'smallTile tile', target:"_blank"},
			d.div({ className : 'smallTileHeader' },
				d.h3({ className : 'headerCopy' }, 'Event Information'),
				d.div({ className : 'endHeader' })
			),
			d.div({ className : 'smallTileCopy'},
				d.a({href:options.meetingInfo.homePageUrl, target:"_blank"}, ' Visit the event website for full details about <span class="notranslate">' + options.meetingInfo.name + "</span>.")
			)
		));
	};



	var d = $j.dom.getContext(this);
}, {
	GUID : 'defaultEventInfoTileWidgetGUID',
	widgetName : 'EventInfoTileWidget'
});

